import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { AdditionalActivityJson } from "../../../DynamicFormsJson/MastersJSON/AdditionalActivity";
import { getAddionalActivity } from "../../../Slice/AdditionalActivity.slice";
import { getStockStakeHolderType } from "../../../Slice/stockStakeHolderType.slice";
import { AdditionalActivityColumns } from "../../../tableColumns/table-columns";
class AdditionalActivityTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { addionalActivity, getAddionalActivity } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={AdditionalActivityJson.formPath}
          screenTitle={AdditionalActivityJson.screenTitle}
          fieldMeta={AdditionalActivityJson.fieldMeta}
          showPdfDownload={AdditionalActivityJson.showPdfDownload}
          showExcelDownload={false}
          changeExcelURL={"contry-data" + '?sort={"sortOrder": "ASC"}'}
          showExtension={false}
          pdfFileName={AdditionalActivityJson.pdfFileName}
          excelFileName={AdditionalActivityJson.excelFileName}
          showAddButton={AdditionalActivityJson.showAddButton}
          tableColumnsToFilter={AdditionalActivityJson.tableColumnsToFilter}
          tableColumns={AdditionalActivityColumns}
          tableData={addionalActivity?.addionalActivity}
          getTableData={getAddionalActivity}
          apiBaseURL={AdditionalActivityJson.apiBaseURL}
          baseIdColumn={AdditionalActivityJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Additional Activity"}
          showDeleteIcon={true}
          showViewButtonInTable={true}
          formPathView={AdditionalActivityJson.formPathView}
          isActiveURL={AdditionalActivityJson.isActiveURL}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  addionalActivity: state.addionalActivity,
});
const mapDispatchToProps = {
  getAddionalActivity,
  getStockStakeHolderType,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalActivityTable);
